import { useTranslation } from 'utils/use-translation'

import useScript from './use-script'

import styles from './styles.module.scss'

const Badges = () => {
  const { t } = useTranslation()

  useScript('https://b.sf-syn.com/badge_js?sf_id=3344301&variant_id=sf')
  useScript('https://b.sf-syn.com/badge_js?sf_id=3344301&variant_id=sd')

  return (
    <div className={styles.badgesContainer}>
      <div>
        <div className="sf-root" data-id="3344301" data-badge="heart-badge-white" data-variant-id="sf" data-metadata="">
          <a
            href="https://sourceforge.net/software/product/CoinRabbit/"
            rel="noopener nofollow noreferrer"
            target="_blank"
          >
            {t('coinrabbit_reviews')}
          </a>
        </div>
      </div>
      <div>
        <div
          className="sf-root"
          data-id="3344301"
          data-badge="users-love-us-new-white"
          data-variant-id="sd"
          data-metadata=""
        >
          <a href="https://slashdot.org/software/p/CoinRabbit/" rel="noopener nofollow noreferrer" target="_blank">
            {t('coinrabbit_reviews')}
          </a>
        </div>
      </div>
    </div>
  )
}

export default Badges
